import { render, staticRenderFns } from "./WaitingLayer.vue?vue&type=template&id=240ca0b6&scoped=true&"
import script from "./WaitingLayer.vue?vue&type=script&lang=js&"
export * from "./WaitingLayer.vue?vue&type=script&lang=js&"
import style0 from "./WaitingLayer.vue?vue&type=style&index=0&id=240ca0b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "240ca0b6",
  null
  
)

export default component.exports